export default __webpack_public_path__ + "static/banner-credit-card-fraud-busters-25a15c5739d32b1a44be5059334616eb.jpg";